import { render, staticRenderFns } from "./ResultadoEvaluacionSection.vue?vue&type=template&id=82509f6e&scoped=true"
import script from "./ResultadoEvaluacionSection.vue?vue&type=script&lang=js"
export * from "./ResultadoEvaluacionSection.vue?vue&type=script&lang=js"
import style0 from "./ResultadoEvaluacionSection.vue?vue&type=style&index=0&id=82509f6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82509f6e",
  null
  
)

export default component.exports